import { Injectable } from '@angular/core';
import { environment } from '../../../../enviroments/enviroment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Menu } from '../models/Menu';

@Injectable({
  providedIn: 'root',
})
export class MenuSystemService {
  private urlEndPoint = environment.urlEndPoint + '/api/menu';

  constructor(private http: HttpClient) {}

  findAll(): Observable<any[]> {
    return this.http.get<any[]>(`${this.urlEndPoint}/all`);
  }

  create(menu: Menu): Observable<any> {
    return this.http.post<any>(`${this.urlEndPoint}-admin`, menu);
  }

  update(menu: Menu): Observable<any> {
    return this.http.put<any>(`${this.urlEndPoint}-admin`, menu);
  }
}
